<template>
    <v-dialog
        v-model="isOpen"
        content-class="v-application v-application--is-ltr vuetify-wrapper pricing-override-dialog"
        width="auto"
    >
        <v-card>
            <v-card-title class="text-h5">
                Preise Anpassen
            </v-card-title>
            <v-card-text class="mt-4 pb-0">
                <service-price-override
                    v-for="(price, service) in pricingOverrides"
                    :key="service"
                    :service="service"
                    :pharmacist.sync="pricingOverrides[service].pharmacist"
                    :pharmacy.sync="pricingOverrides[service].pharmacy"
                    :margin.sync="margins[service]"
                />
            </v-card-text>
            <v-card-actions class="mb-3">
                <v-spacer></v-spacer>
                <v-btn @click="isOpen = false" text outlined>
                    Abbrechen
                </v-btn>
                <v-btn
                    @click="submit"
                    :loading="isLoading"
                    color="primary"
                    class="ml-4 save-btn"
                    :disabled="!appointmentIds.length"
                    depressed
                >
                    Speichern
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import axios from 'axios';
import { mapMutations } from 'vuex';
import ServicePriceOverride from './ServicePriceOverride.vue';

export default {
    name: 'PricingOverrideBtn',
    components: {
        ServicePriceOverride
    },
    props: {
        value: Boolean,
        pharmacyId: String,
        appointmentIds: Array,
        defaultOverrides: Object,
    },
    data() {
        const substitutionOverride = this.defaultOverrides?.substitution;
        const ptaOverride = this.defaultOverrides?.pta;
        const pkaOverride = this.defaultOverrides?.pka;
        return {
            isLoading: false,
            pricingOverrides: {
                substitution: {
                    pharmacist: null,
                    pharmacy: null,
                    ...substitutionOverride,
                },
                pta: {
                    pharmacist: null,
                    pharmacy: null,
                    ...ptaOverride,
                },
                pka: {
                    pharmacist: null,
                    pharmacy: null,
                    ...pkaOverride,
                },
            },
            margins: {
                substitution: substitutionOverride?.pharmacy - substitutionOverride?.pharmacist || null,
                pta: ptaOverride?.pharmacy - ptaOverride?.pharmacist || null,
                pka: pkaOverride?.pharmacy - pkaOverride?.pharmacist || null
            },
        };
    },
    methods: {
        async submit() {
            this.isLoading = true;
            try {
                const response = await axios.put(`/pharmacies/${this.pharmacyId}/override_pricing`, {
                    appointment_ids: this.appointmentIds,
                    pricing_override: this.pricingOverrides
                });
                this.alertSuccess('gespeichert');
                this.$emit('fetch-appointments')
            } catch (error) {
                this.alertError()
            }
            finally {
                this.isOpen = false;
                this.isLoading = false;
            }
        },
        ...mapMutations({
            alertError: 'alert/error',
            alertSuccess: 'alert/success',
        })
    },
    computed: {
        isOpen: {
            get() {
                return this.value
            },
            set(state) {
                this.$emit('input', state)
            }
        },
    }
};
</script>

<style scoped>
.btn-primary {
    color: #fff !important;
    background-color: #337ab7 !important;
    border-color: #2e6da4 !important;
}

.black--text {
    color: black;
}

.description {
    max-width: 600px;
    margin: 0 auto;
}

.wrapper {
    margin: 0 auto;
    display: flex;
    justify-content: center;
}

.wrapper>div {
    margin: 0 1em;
}

.content {
    width: 500px;
}

.abort {
    color: rgba(0, 0, 0, .5) !important;
}

.submit {
    color: #337ab7 !important;
}

.bootstrap-button {
    /** Make it look the same as the bootstrap buttons */
    border-radius: 3px;
    border-color: #ccc;
    width: 34px !important;
    height: 30px !important;
}
</style>
